<script setup>
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Link :href="'/'">
        <img width="100px" src="/assets/images/ppi-logo.png">
    </Link>
</template>
